import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
import { defaultInputWrapperStyles, InputWrapperStyleProps, inputWrapperStylesMap } from "@/components/global/form/inputs/styles/input-wrapper.styles";
interface InputWrapperProps {
  error?: string;
  disabled?: boolean;
  children: React.ReactNode;
  styles?: InputWrapperStyleProps;
}

/**
 * Form field wrapper component providing styling for the input container
 * @param {string} [error] - Error message (affects styling)
 * @param {boolean} [disabled] - Whether the input is disabled
 * @param {React.ReactNode} children - The input element to wrap
 * @param {InputWrapperStyleProps} [styles] - Custom styles for the wrapper
 * @example
 * <InputWrapper
 *   error={errorMessage}
 *   disabled={isDisabled}
 *   styles={{
 *     height: "md",
 *     rounded: "lg",
 *     borderColor: "primary"
 *   }}
 * >
 *   <input type="text" />
 * </InputWrapper>
 */
export const InputWrapper = t0 => {
  const $ = _c(13);
  const {
    error,
    disabled,
    children,
    styles: t1
  } = t0;
  let t2;
  let t3;
  if ($[0] !== disabled || $[1] !== error || $[2] !== t1) {
    const styles = t1 === undefined ? {} : t1;
    const mergedStyles = {
      ...defaultInputWrapperStyles,
      ...styles
    };
    t3 = "w-full relative";
    t2 = twMerge("flex border items-center justify-center relative", inputWrapperStylesMap.height[mergedStyles.height], inputWrapperStylesMap.rounded[mergedStyles.rounded], `border-${mergedStyles.borderColor}`, disabled && [`bg-${mergedStyles.disabledStyle?.backgroundColor}`, `border-${mergedStyles.disabledStyle?.borderColor}`, `text-${mergedStyles.disabledStyle?.textColor}`], error && [`border-${mergedStyles.errorColor}`, "bg-danger3"], mergedStyles.className);
    $[0] = disabled;
    $[1] = error;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = <div className="relative flex items-center justify-center w-full">{children}</div>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};